/*
* function that if set will return the url to return to after login, ie window.unify.login.returnUriProvider = function(){ return 'URL'; }
*/
export var returnUriProvider;

export class Login {
    constructor(o) {
        o = typeof o !== 'undefined' ? o : {};
        this.endpoints = o.endpoints;
        this.translations = o.translations;

        if (typeof this.endpoints === 'undefined') {
            throw 'Login class called without property endpoints';
        }

        if (typeof this.endpoints.SignInUri === 'undefined') {
            throw 'Login class called without property endpoints.SignInUri';
        }

        if (typeof this.translations === 'undefined') {
            throw 'Login class called without property translations';
        }

        if (typeof this.translations.internal.SignInLinkText === 'undefined') {
            throw 'UserMenuModal class called without property translations.internal.SignInLinkText';
        }
    }

    html() {
        var signIn = this.translations.internal.SignInLinkText;
        return '<button class="unify-button-secondary unify-transparent" onclick="window.unify.login.initiateLogin();">' + signIn + '</button>';
    }

    initiateLogin() {
        var loginUrl = this.endpoints.SignInUri + "?redirectUri=" + encodeURIComponent(this.getRedirectUrlAfterLoggedIn());
        window.location.replace(loginUrl);
    }

    getRedirectUrlAfterLoggedIn() {
        if (typeof window.unify.returnUriProvider === "function") {
            return returnUriProvider();
        }
        return window.location.href;
    }
}